<template>
  <div>
    <!-- 判斷用戶是否已登入 -->
    <div v-if="isAuthenticated">
      <div class="dropdown-menu flex mt-4 mb-4 mr-4">
        <!-- 語言選單 -->
        <div
          ref="setting"
          class="dropdown relative dropdown-content"
        >
          <button
            class="icon-settings-button"
            aria-label="setting"
            @click="toggleMenu('setting')"
          />
          <div
            v-if="isOpen.setting"
            class="absolute bg-white border border-gray-300 rounded shadow-lg right-0 min-w-[260px] sm:min-w-[280px] cursor-pointer hover:bg-gray-200"
          >
            <div class="m-4">
              <!-- 語言選項 -->
              <LanguageSwitch
                :with-label="true"
                @language-switch-closed="closeDropdownMenu"
              />
            </div>
          </div>
        </div>

        <!-- 快捷列 -->
        <button
          ref="application"
          class="dropdown relative dropdown-content"
          aria-haspopup="true"
          :aria-expanded="isOpen.application"
          aria-label="application"
          @click="toggleApplication()"
        >
          <div class="ml-1">
            <ZynetApps />
          </div>
        </button>

        <!-- 使用者帳戶選單 -->
        <div
          ref="account"
          class="dropdown relative dropdown-content"
        >
          <button
            class="m-1.5 w-9 h-9 bg-gray-500 rounded-full flex items-center justify-center text-white"
            aria-label="account"
            @click="toggleMenu('account')"
          >
            {{ firstNameInitial
            }}
          </button>
          <div
            v-if="isOpen.account"
            class="absolute bg-white border border-gray-300 rounded shadow-lg right-0 min-w-[260px] sm:min-w-[280px]"
          >
            <!-- 帳戶選項 -->
            <div class="flex items-center border-b border-gray-300">
              <div class="m-4 w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center text-white">
                {{
                  firstNameInitial }}
              </div>
              <div class="mr-4">
                <span class="text-base">{{ userFullName }}</span><br>
                <span class="text-sm">{{ userEmail }}</span>
              </div>
            </div>
            <button
              class="group flex items-center w-full cursor-pointer hover:bg-gray-200"
              @click="signOut"
            >
              <img
                src="@/assets/svg/icon_48px_signout.svg"
                class="m-4 w-8 h-8"
                aria-hidden="true"
                alt=""
              >
              <span class="text-gray-500 group-hover:text-gray-700">{{ $t('messages.button.sign_out') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import LanguageSwitch from '@/components/LanguageSwitch.vue';
import ZynetApps from '@/components/ZynetApps.vue';

export default {
  name: 'DropdownMenu',
  components: {
    LanguageSwitch,
    ZynetApps
  },
  setup() {
    const authStore = useAuthStore();

    const isAuthenticated = computed(() => authStore.isAuthenticated);

    const firstNameInitial = computed(() => {
      const { first_name } = authStore.current_user || {};
      return first_name ? first_name.charAt(0).toUpperCase() : '';
    });

    const userFullName = computed(() => {
      const { first_name, last_name } = authStore.current_user || {};
      return `${first_name || ''} ${last_name || ''}`.trim();
    });

    const userEmail = computed(() => {
      return authStore.current_user?.email || '';
    });

    return { isAuthenticated, firstNameInitial, userFullName, userEmail };
  },
  data() {
    return {
      isOpen: {
        setting: false,
        application: false,
        account: false
      }
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleApplication() {
      this.isOpen.setting = false;
      this.isOpen.account = false;
      this.toggleFocusEffect("application");
    },
    toggleMenu(menu) {
      this.isOpen[menu] = !this.isOpen[menu];
      for (const key in this.isOpen) {
        if (key !== menu) {
          this.isOpen[key] = false;
        }
      }
      this.toggleFocusEffect(menu);
    },
    toggleFocusEffect(menu) {
      // 遍歷所有選單項目並刪除焦點效果
      for (const key in this.$refs) {
        if (this.$refs[key].classList) {
          this.$refs[key].classList.remove('focus-effect');
        }
      }
      // 僅為目前選單項目新增焦點效果
      if (this.isOpen[menu]) {
        this.$refs[menu].classList.add('focus-effect');
      }else if (menu === "application") {
        this.$refs["application"].classList.add('focus-effect');
      }
    },
    signOut() {
      const authStore = useAuthStore();
      authStore.logout();
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdownMenu();
      }
    },
    closeDropdownMenu() {
      this.isOpen.setting = false;
      this.isOpen.application = false;
      this.isOpen.account = false;
      for (const key in this.$refs) {
        if (this.$refs[key].classList) {
          this.$refs[key].classList.remove('focus-effect');
        }
      }
    },
  }
};
</script>

<style>
.dropdown-menu {
  position: relative;
  z-index: 10;
}

.icon-settings-button {
  width: 48px;
  height: 48px;
  background-image: url('@/assets/svg/icon_48px_settings.svg');
  background-size: cover;
  border: none;
  cursor: pointer;
}

.icon-applications-button {
  width: 48px;
  height: 48px;
  background-image: url('@/assets/svg/icon_48px_applications.svg');
  background-size: cover;
  border: none;
  cursor: pointer;
}

.zyAppLauncher-popover {
  font-family: 'Inter-Light-18pt', sans-serif;
}

.zyAppLauncher-popover a {
    font-size: 14px;
    color: #3a3a3a;
}

/* 新增的 hover 效果 */
.dropdown-content {
  width: 50px;
  height: 50px;
}

.dropdown-content:hover {
  background-color: #E0F2CC;
  border-radius: 50%;
}

.focus-effect {
  background-color: #E0F2CC;
  border-radius: 50%;
}

</style>
